import React, { CSSProperties } from 'react';

export const AnnounceChange: React.FC<{
  style?: CSSProperties;
}> = ({ children, ...props }) => (
  <div aria-live="polite" aria-relevant="all" {...props}>
    {children}
  </div>
);
